import type {ExampleSeedDataConfig} from 'analysis-tool/create-analysis-modal/ExampleSeedDataConfigEditor';
import {WorksheetSeedDataConfig} from 'notebook/worksheets/components/WorksheetAnalysis';
import {MultipleProcedureRunsSeedDataConfig} from 'studies/typed/shared/MultiProcedureRunAnalysis';
import {MultipleStudiesSeedDataConfig} from 'studies/typed/shared/MultiStudyAnalysis';
import {SingleProcedureRunSeedDataConfig} from 'studies/typed/shared/SingleProcedureRunAnalysis';

/**
 * Keep in sync with usages of `@register_seed_data_type` on the backend.
 */

export enum SeedDataConfigType {
  /**
   * This is an example for configuring seed data. Search all usages of `EXAMPLE_SEED_DATA`
   * on the frontend / backend to see how to properly register a new seed data configuration.
   */
  EXAMPLE_SEED_DATA = 'EXAMPLE_SEED_DATA',
  PROCEDURE_RUN = 'PROCEDURE_RUN',
  WORKSHEET = 'WORKSHEET',
  MULTIPLE_PROCEDURE_RUNS = 'MULTIPLE_PROCEDURE_RUNS',
  MULTIPLE_STUDIES = 'MULTIPLE_STUDIES',
}

/**
 * Union type of all possible seed data configurations. Each type should be a BaseSeedDataConfig.
 *
 * This shape should match the seed data configuration as handled by the backend.
 */
export type SeedDataConfig =
  | ExampleSeedDataConfig
  | SingleProcedureRunSeedDataConfig
  | WorksheetSeedDataConfig
  | MultipleProcedureRunsSeedDataConfig
  | MultipleStudiesSeedDataConfig;

export interface BaseSeedDataConfig<T extends SeedDataConfigType, U> {
  type: T;
  data: U;
}
